module.exports = __webpack_public_path__ + "img/hr-level1_dead.1fc515bb.png";